const Kategoriya2223 = () => {
    return (
        <div style={{ fontFamily: "Times New Roman", fontSize: "14pt" }} className="container mt-5">
            <h3 className="text-center text-primary">
                2-sinf 2-chorak<br />
                Mavzu: So‘z ichida yonma-yon kelgan bir xil undoshlar talaffuzi va imlosini o‘rganamiz <br />
“Sal murakkab” bo‘limidagi topshiriqlar va ularni o‘tkazish metodikasi
            </h3>
            <b>1-mashq. Juftlikda ishlang. To‘g‘ri yozilgan so‘zlarning tagiga chizing.</b><br />
            <i>Ta’limiy maqsad:</i> O‘quvchilarning yonma-yon kelgan undoshlar imlosi haqidagi bilimlarini mustahkamlash.<br />
            <i>Mashg‘ulot davomiyligi:</i> 3 daqiqa <br />
            <ul>
                <li>makka</li>
                <li>hato</li>
                <li>latta</li>
                <li>mujasam</li>
                <li>mutafakir</li>
                <li>muyasar</li>
                <li>novot</li>
                <li>oddiy</li>
            </ul>
            <p><b>2-mashq. Juftlikda ishlang. Aralash berilgan so‘zlarni o‘qing va noto‘g‘ri yozilgan so‘zlarni aniqlab, to‘g‘risini yozing.</b></p>
            <p><i>Ta’limiy maqsad:</i> O‘quvchilarning yona-yon kelgan undoshlar imlosi ustida ishlash ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3 daqiqa.</p>
            <p>Haqush, iki, illat, labay, hakka, hamma, lazat, mujasam, muhayo, mutafakir, mula, lobulamoq, albatta, assalom, ayom, ayor, achchiq, balon.</p>
            <p><b> 3-mashq. FDM usuli asosida ibora ma’nosi haqida fikr yuriting.</b></p>
            <p><i>Ta’limiy maqsad:</i>O‘quvchilarning bog‘lanishli nutqini rivojlantirish ko‘nikmalarini rivojlantirish.</p>
            <p><i>Mashg‘ulot davomiyligi:</i>3-4 daqiqa.</p>
            <p className="text-center">Tepa sochi tikka bo‘lmoq</p>
            <p className="text-break">Fikr - ___________________________________________________________</p>
            <p className="text-break">Dalil - _________________________________________________________</p>
            <p className="text-break">Misol - _______________________________________________________</p>
        </div>
    )
}
export default Kategoriya2223;